/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_AssemblyaiInputs */



/**
* | output |
* | --- |
* | "Assembly AI" |
*
* @param {Voice_Manager_Provider_AssemblyaiInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_assemblyai = /** @type {((inputs?: Voice_Manager_Provider_AssemblyaiInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_AssemblyaiInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Assembly AI")
	if (locale === "de") return /** @type {LocalizedString} */ ("Assembly AI")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assembly AI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Assembly AI")
	if (locale === "es") return /** @type {LocalizedString} */ ("Assembly AI")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Assembly AI")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Assembly AI")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Assembly AI")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Assembly AI")
	return /** @type {LocalizedString} */ ("Assembly AI")
});